/**
 * Internal depenedencies
 */
import {
  GRAPH_CUBE_META_REQUEST,
  GRAPH_CUBE_META_REQUEST_SUCCESS,
  GRAPH_CUBE_META_REQUEST_FAILURE,
} from "state/action-types";

import cubejsApi from "lib/cube-js";

/**
 * [description]
 *
 * @return {[type]} [description]
 */
export default () => {
  return (dispatch, getState) => {
    dispatch({
      type: GRAPH_CUBE_META_REQUEST,
    });
    return cubejsApi
      .meta()
      .then((meta) =>
        dispatch({
          type: GRAPH_CUBE_META_REQUEST_SUCCESS,
          payload: { meta },
        })
      )
      .catch((error) => {
        dispatch({
          type: GRAPH_CUBE_META_REQUEST_FAILURE,
          error,
        });
      });
  };
};
